




















































































import { Guid } from 'guid-typescript'
import { escape, unescape } from 'lodash'
import Mexp from 'math-expression-evaluator'
import { Component, Emit, Mixins, Prop, Ref, VModel, Vue } from 'vue-property-decorator'

import { SelectOption } from '../../logic/types'
import { UseFields } from '../Pi'
import { FieldData, SelectOptionData } from '../Pi/types'

@Component
export default class FormulaInput extends Mixins(UseFields) {
  @VModel({ type: String, required: true, default: '' }) text!: string

  @Prop({ type: Array, default: () => [] }) mentionItems!: Array<SelectOption>

  @Prop() errorMessage!:string

  @Ref('textArea') textArea!: Vue

  @Ref('layoutArea') layoutArea!: HTMLDivElement

  @Ref('mention-list') mentionList!: HTMLUListElement

  mexp = new Mexp()

  @Emit('input')
  input(outputString: string): string | undefined {
    this.setHeight()

    if (outputString !== '') {
      try {
        this.mexp.eval(this.replaceMentionMatchText(outputString, () => '1', () => 'NaN'))
        this.validationChange(true)
        return outputString
      } catch (e) {
        this.validationChange(false)
      }
    } else {
      this.validationChange(true)
    }
  }

  @Emit('validationChange')
  validationChange(isValid: boolean): boolean {
    this.isValueValid = isValid
    return isValid
  }

  isMentionVisible = false

  isInfoModalOpen = false

  selectedVariable = this.itemsOptions[0]?.value ?? ''

  selectedNode: null | Element = null

  openBraceIndex: number | null = null

  searchText = ''

  isValueValid = false

  get itemsOptions(): Array<SelectOptionData> {
    if (this.mentionItems && this.mentionItems.length) {
      return this.mentionItems.slice().map(option => ({
        value: '{' + option.value + '}',
        label: option.label
      }))
    }

    return []
  }

  get searchQueryItems(): Array<SelectOption> {
    if (this.searchText.length) {
      return this.mentionItems.filter(i => i.value.includes(this.searchText))
    } else {
      return this.mentionItems
    }
  }

  safe_tags_replace(str: string) {
    return escape(str)
  }

  setHeight():void {
    (this.textArea.$el as any).style.height = "5px";
    (this.textArea.$el as any).style.height = ((this.textArea.$el as any).scrollHeight)+"px";
  }

  setupFn(args: FieldData): FieldData {
    args.setter = (value: any): any => this.$set(args.model, args.key, value)
    return args
  }

  replaceMentionMatchText(text: string, onMatch: (match: any) => string, onFail: (match: any) => string): string {
    const curly_braces_text_regexp = new RegExp('{[^{]*[^}]}', 'g')
    const replacer = (match: any) => {
      if (this.mentionItems.some(option => String('{' + option.value + '}') === unescape(match))) return onMatch(match)
      return onFail(match)
    }

    return text.replace(curly_braces_text_regexp, replacer)
  }

  getTextAreaValue(): string {
    return (this.textArea.$el as HTMLTextAreaElement).value
  }

  setTextAreaValue(string: string): void {
    (this.textArea.$el as HTMLTextAreaElement).value = string
    this.input(string)
  }

  caretPosition(): number {
    return (this.textArea.$el as HTMLTextAreaElement).selectionStart!
  }

  setCaret(element: HTMLTextAreaElement | HTMLInputElement, position: number): void {
    element.setSelectionRange(position, position)
    element.focus()
  }

  setLayoutMarkup(value: string): void {
    const onMatch = (match: string) => `<span variable-key="${ Guid.create() }" class="variable_data">${ match }</span>`
    const onFail = (match: string) => match

    this.layoutArea.innerHTML = this.replaceMentionMatchText(value, onMatch, onFail)
  }

  replaceTextareaValue(text: string, newItem: string, openIndex: number): string {
    return text.slice(0, openIndex) + '{' + newItem + '}' + text.slice(this.searchText.length > 0 ? this.openBraceIndex! + this.searchText.length : this.openBraceIndex!)
  }

  selectItem(item: string): void {
    this.isMentionVisible = false
    this.setTextAreaValue(this.replaceTextareaValue(this.getTextAreaValue(), item, this.openBraceIndex! - 1))
    this.setLayoutMarkup(this.safe_tags_replace(this.getTextAreaValue()))
    this.setCaret(this.textArea.$el as HTMLTextAreaElement, this.openBraceIndex! + item.length + 1)
  }

  isPreviousCharBrace(): boolean {
    return this.getTextAreaValue().charAt(this.caretPosition() - 1) === '{'
  }

  removeTextBetweenBraces(text: string, position: number): string {
    // get first part of word {ab...| , where | is cursor position
    const firstReg = new RegExp('{[^{}]*$', '')
    const firstPart = text.substring(0, position)

    // get second part of word |..cd} , where | is cursor position
    const secondReg = new RegExp('^[^{}]*}', '')
    const secondPart = text.substring(position)

    if (firstReg.test(firstPart) && secondReg.test(secondPart)) {
      return firstPart.replace(firstReg, '') + secondPart.replace(secondReg, '')
    }

    return text
  }

  removeTextToOpenBrace(text: string, position: number): string | null {
    const textFindTo = text.slice(0, position).trim()
    const endOfText = text.slice(position)
    const reg = new RegExp('{[^}{]+.{1}$', '')

    if (reg.test(textFindTo)) {
      return textFindTo.replace(reg, '') + endOfText + ' '
    }

    return null
  }

  removeTextToCloseBrace(text: string, position: number): string | null {
    const textFindTo = text.slice(position)
    const startOfText = text.slice(0, position)
    const reg = new RegExp('^{[^{}]*}', '')

    if (reg.test(textFindTo)) {
      // space in replaceValue arg in replace() to prevent removing last char in txtarea
      return startOfText + textFindTo.replace(reg, ' ')
    }

    return null
  }

  newOffsetPosition(value: string, regexp: RegExp, direction: 'left' | 'right'): number | null {
    if (direction === 'left') {
      const sliced = value.slice(0, this.caretPosition() - 1)
      const match = sliced.match(regexp)

      if (match) {
        return this.caretPosition() - match[0].length
      }

      return null
    } else {
      const sliced = value.slice(this.caretPosition())
      const match = sliced.match(regexp)
      if (match) {
        return this.caretPosition() + match[0].length - 1
      }

      return null
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  handleKeyDown(event: KeyboardEvent): void {
    const value = (event.target as HTMLTextAreaElement).value

    if (event.code === 'ArrowRight' && value.charAt(this.caretPosition()) === '{') {
      const reg = new RegExp('^.[^}{]*}', '')
      const newPosition = this.newOffsetPosition(value, reg, 'right')

      if (newPosition) this.setCaret((this.textArea.$el as HTMLTextAreaElement), newPosition)
    }

    if (event.code === 'ArrowLeft' && value.charAt(this.caretPosition() - 1) === '}') {
      const reg = new RegExp('{[^}{]+.{1}$', '')
      const newPosition = this.newOffsetPosition(value, reg, 'left')

      if (newPosition) this.setCaret((this.textArea.$el as HTMLTextAreaElement), newPosition)
    }

    /*if mention menu visible start*/
    if (this.isMentionVisible) {
      const listItems = Array.from(this.mentionList.children)
      const activeClass = 'items-popover__item-active'

      /*handle Enter to select item*/
      if (event.code === 'Enter') {
        const item = listItems.find(i => i.classList.contains(activeClass))

        if (item) {
          this.selectItem(item.getAttribute('data-item-value') as string)
        }
      }

      /*handle ArrowDown and ArrowUp to go through items*/
      if (event.code === 'ArrowDown') {
        for (let i = 0; i < listItems.length; i++) {
          const currentElem = listItems[i]
          const nextElem = listItems[i + 1]

          if (currentElem.classList.contains(activeClass)) {
            currentElem.classList.remove(activeClass)
            if (nextElem) {
              nextElem.classList.add(activeClass)
              nextElem.scrollIntoView({ block: "center", inline: "center" })
            } else {
              listItems[0].classList.add(activeClass)
              listItems[0].scrollIntoView({ block: "center", inline: "center" })
            }

            break
          }
        }
      }

      if (event.code === 'ArrowUp') {
        for (let i = 0; i < listItems.length; i++) {
          const currentElem = listItems[i]
          const prevElem = listItems[i - 1]

          if (currentElem.classList.contains(activeClass)) {
            currentElem.classList.remove(activeClass)
            if (prevElem) {
              prevElem.classList.add(activeClass)
              prevElem.scrollIntoView({ block: "center", inline: "center" })
            } else {
              listItems[listItems.length - 1].classList.add(activeClass)
              listItems[listItems.length - 1].scrollIntoView({ block: "center", inline: "center" })
            }

            break
          }
        }
      }
    }
    /*if mention menu visible end*/

    /*delete and backspace*/
    if ([ 'Delete', 'Backspace' ].includes(event.code)) {
      const caretOffset = event.code === 'Backspace' ? -1 : 0
      const removedChar = value[this.caretPosition() + caretOffset]
      let newText: string | null

      newText = this.removeTextBetweenBraces(value, this.caretPosition())

      if ((this.textArea.$el as HTMLTextAreaElement).selectionStart === (this.textArea.$el as HTMLTextAreaElement).selectionEnd) {
        if (removedChar === '}') {
          if (event.code === 'Backspace') {
            newText = this.removeTextToOpenBrace(value, this.caretPosition())
          } else {
            newText = this.removeTextToOpenBrace(value, this.caretPosition() + 1)
          }
        }

        if (removedChar === '{') {
          if (event.code === 'Backspace') {
            newText = this.removeTextToCloseBrace(value, this.caretPosition() - 1)
          } else {
            newText = this.removeTextToCloseBrace(value, this.caretPosition())
          }
        }
      }

      if (newText !== null) {
        this.setTextAreaValue(newText)
      } else {
        this.setTextAreaValue(value)
      }

      setTimeout(() => {
        this.setLayoutMarkup(this.safe_tags_replace((event.target as HTMLTextAreaElement).value))
      }, 0)
    }

    setTimeout(() => {
      if ([ 'ArrowRight', 'ArrowLeft' ].includes(event.code)) {
        this.isMentionVisible = this.isPreviousCharBrace()
      }
    }, 0)

    if (!value.trim().length) {
      this.resetFields()
    }
  }

  handleInput(event: InputEvent): void {
    const targetValue = (event.target as HTMLTextAreaElement).value
    const findOpenBracket = new RegExp('{[^{}]*$', '')
    this.setLayoutMarkup(this.safe_tags_replace(targetValue))

    if (event.data === '{' || this.isPreviousCharBrace()) {
      this.openBraceIndex = this.caretPosition()
      this.isMentionVisible = true
      this.searchText = ''
    } else if (findOpenBracket.test(targetValue)) {
      this.searchText = targetValue.substring(this.openBraceIndex!, this.caretPosition())
      this.isMentionVisible = this.mentionItems.some(i => i.value.includes(this.searchText))
    } else if (!targetValue.trim().length) {
      this.resetFields()
    } else {
      this.resetFields()
    }

    this.input(targetValue)
  }

  resetFields(): void {
    this.openBraceIndex = null
    this.searchText = ''
    this.isMentionVisible = false
  }

  clearSelectedNode(): void {
    this.selectedNode = null
    this.selectedVariable = null
  }

  handleOk(): void {
    if (this.selectedNode) {
      this.selectedNode.innerHTML = this.selectedVariable
      this.isInfoModalOpen = false
      this.setTextAreaValue(this.layoutArea.innerText)
    }
  }

  handleLayoutAreaClick(event: Event): void {
    const variableKey = ((event.target) as HTMLElement).getAttribute('variable-key')

    if (variableKey) {
      this.isInfoModalOpen = true

      document.querySelectorAll('.variable_data').forEach(node => {
        if (node.getAttribute('variable-key') === variableKey) {
          this.selectedNode = node
          this.selectedVariable = (node as HTMLSpanElement).innerText
        }
      })
    }
  }

  handleWindowClick(event: Event):void {
    if ((event.target as HTMLElement).id !== 'mentionListPopover') {
      this.isMentionVisible = false
    }
  }

  mounted(): void {
    this.setTextAreaValue(this.text)
    this.setLayoutMarkup(this.text)

    this.layoutArea.addEventListener('click', this.handleLayoutAreaClick)
    window.addEventListener('click', this.handleWindowClick)
  }

  destroyed(): void {
    removeEventListener('click', this.handleLayoutAreaClick)
    window.addEventListener('click', this.handleWindowClick)
  }
}
